
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home, RefreshCw } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Add detailed logging for debugging
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    console.log("Current window location:", window.location.href);
    console.log("Full path with search params:", location.pathname + location.search);
    console.log("Browser user agent:", navigator.userAgent);
    console.log("Document base URI:", document.baseURI);
    
    // Debug history state
    try {
      console.log("History state:", JSON.stringify(window.history.state));
    } catch (e) {
      console.log("Could not stringify history state:", e);
    }
    
    // Debug deployed environment
    console.log("Environment check:", {
      isPreview: window.location.hostname.includes("preview") || window.location.hostname.includes("lovable.app"),
      hostname: window.location.hostname,
      protocol: window.location.protocol,
    });
  }, [location.pathname]);

  // Function to attempt manual navigation using history API
  const attemptManualNavigation = () => {
    // Use history.pushState to manually set the route without a page reload
    window.history.pushState({}, '', '/');
    // Dispatch a popstate event to trigger the router
    window.dispatchEvent(new PopStateEvent('popstate'));
    // Also try to directly navigate to ensure it works
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Navbar />
      
      <main className="flex-grow flex items-center justify-center p-4">
        <div className="max-w-md w-full text-center">
          <div className="rounded-full bg-red-100 p-3 w-16 h-16 flex items-center justify-center mx-auto mb-6">
            <span className="text-red-600 text-2xl font-bold">404</span>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Page not found</h1>
          
          <p className="text-gray-600 mb-4">
            The page you are looking for doesn't exist or has been moved.
          </p>
          
          <div className="bg-gray-100 p-3 rounded-md mb-6 overflow-auto max-h-32 text-left">
            <p className="text-xs font-mono">Path: {location.pathname}</p>
            <p className="text-xs font-mono">Full URL: {window.location.href}</p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="outline"
              className="flex items-center gap-2"
              onClick={() => window.history.back()}
            >
              <ArrowLeft className="h-4 w-4" />
              Go Back
            </Button>
            
            <Button 
              className="flex items-center gap-2 bg-brand-blue hover:bg-brand-blue/90"
              asChild
            >
              <Link to="/">
                <Home className="h-4 w-4" />
                Return Home
              </Link>
            </Button>
            
            <Button
              variant="outline"
              className="flex items-center gap-2"
              onClick={attemptManualNavigation}
            >
              <RefreshCw className="h-4 w-4" />
              Force Navigate
            </Button>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
